import Vue from "vue";
import Vuex from "vuex";
// import createPersistedState from "vuex-persistedstate";
import actions from "@/store/actions";
import getters from "@/store/getters";
import mutations from "@/store/mutations";
import modules from "@/store/modules";

const debug = process.env.NODE_ENV !== "production";

const state = () => ({
  activeTrail: []
});

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules,
  strict: debug,
  plugins: debug ? [] : []
});
